import { connect } from 'react-redux';
import EditManageBroadcast from 'Components/Broadcast/Team/Edit/index';
import { TeamAction } from 'Actions';

function mapStatetoProps(state){
    const { 
        usersId, usersList, usersTotalRecords, error, formLoading, editErrorElement,
        editFormObj: { 
            aboutTeam, createdAt, id, image, isActive, teamMembers = [], teamMembersCount, teamName,
        } = {} ,  
    } = state.team
    return{
        error,
        usersId,
        usersList:usersList,
        usersTotalRecords:usersTotalRecords,
        formLoading,
        editErrorElement,
        aboutTeam, createdAt,
        id, image, isActive, teamMembers, teamMembersCount, teamName,
    } 
}
const mapDispatchtoProps = {
    fetchUsers:TeamAction.fetchUsers,
    addTeamImage:TeamAction.addTeamImage,
    updateTeam:TeamAction.updateTeam,
    fetchEditObj: TeamAction.fetchEditObj,
}

export default connect(mapStatetoProps,mapDispatchtoProps)(EditManageBroadcast)